import http from 'plugins/axios';

export default {
  getAllCoins() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  },
  getCoinAddressList({userId, coinType, address, memo, version, page, size}) {
    return http.get({
      url: '/admin/trade/user/userAddress',
      data: {
        userId,
        coinType,
        address,
        memo,
        version,
        page,
        size
      }
    });
  },
  addNewCoinAddress({coinType, address, memo}) {
    return http.post({
      url: '/admin/trade/user/addNewAddress',
      data: {
        address,
        memo,
        coinType
      },
      dataType: 'form'
    });
  }
};
